const gcdCalc = (a: number, b: number): number => {
  // Helper function to calculate the greatest common divisor (GCD)
  if (!b) {
    return a
  }
  return gcdCalc(b, a % b)
}

export const getAdjustedAspectRatioString = (
  widthPx: number,
  heightPx: number
) => {
  const aspectRatio16x9 = 16 / 9
  const aspectRatio9x16 = 9 / 16
  const aspectRatioDeviationThreshold = 0.05
  const actualAspectRatio = widthPx / heightPx
  const gcd = gcdCalc(widthPx, heightPx)

  if (
    Math.abs(actualAspectRatio - aspectRatio16x9) <
    aspectRatioDeviationThreshold
  ) {
    return '16:9'
  }

  if (
    Math.abs(actualAspectRatio - aspectRatio9x16) <
    aspectRatioDeviationThreshold
  ) {
    return '9:16'
  }

  return `${widthPx / gcd}:${heightPx / gcd}`
}
